import { FC } from "react";
import { MdsIconKind } from "@/design-system/components/icon";
import { MDSComboboxItem } from "./combobox.types";
import { MDSComboboxListItemIcon } from "./combobox-list-item-icon";
import { MDSComboboxListItemMetadata } from "./combobox-list-item-metadata";
import {
  StyledListBoxItem,
  StyledContentContainer,
  StyledTitleRow,
  StyledTitle,
  StyledSharedIcon,
} from "./combobox-list-item.style";
import { MDSListBoxSlotName } from "@/mds/components/lists/list-box-item";

type Props = {
  item: MDSComboboxItem;
  showMetadata?: boolean;
};

export const MDSComboboxListItem: FC<Props> = ({ item, showMetadata = true }) => {
  const metadata = item.metadata || {};
  const isShared = metadata.isShared as boolean | undefined;

  return (
    <StyledListBoxItem id={item.id} data-mds-name="combobox-list-item">
      <span slot={MDSListBoxSlotName.LeftAddon}>
        <MDSComboboxListItemIcon kind={item.kind} collectionId={item.id} />
      </span>
      <StyledContentContainer>
        <StyledTitleRow>
          <StyledTitle>{item.label}</StyledTitle>
          {isShared && <StyledSharedIcon kind={MdsIconKind.Shared} />}
        </StyledTitleRow>
        <MDSComboboxListItemMetadata
          kind={item.kind}
          metadata={metadata}
          showMetadata={showMetadata}
        />
      </StyledContentContainer>
    </StyledListBoxItem>
  );
};
